/**
 * @file index.js
 * @author Daniel Aguirre
 * @description CorrelationRiskRateProgression View.
 */

// Commons
import {
  mapStateToProps,
  mapDispatchToProps
} from '@nephro/commons/mapReduxCRUD/index';

// Dependencies
import { connect } from 'react-redux';

// View
import View from './CorrelationRiskRateProgressionView';

export const mapStateToPropsCorrelationRiskRateProgression = mapStateToProps;
export const mapDispatchToPropsCorrelationRiskRateProgression =
  mapDispatchToProps;

export default connect(
  mapStateToPropsCorrelationRiskRateProgression,
  mapDispatchToPropsCorrelationRiskRateProgression
)(View);
